import _ from 'underscore';
import formatDate from './utils/formatdate';
import convertDate from './utils/convertdate';
import TabsView from './views/tabsview';
import VideoTagView from './views/videotagview';
import TagModel from './models/tagmodel';
import CommunicationModel from './models/communicationmodel';
import DeptLocCommModel from './models/deptloccommmodel';
import DeptLocModel from './models/deptlocmodel';
import uploadVideoThumbnail from './utils/uploadvideothumbnail';
import uploadTeamMemberImage from './utils/uploadteammemberimage';
import uploadPdf from './utils/uploadpdf';
import fileToBase64 from './utils/filetobase64';
import CollectionInput from './views/collectioninput';
import CkeditorCollectionInput from './views/ckeditorcollectioninput';

const domainURL = $('body').data('domain');

const ModalView = Backbone.View.extend({
  el: '#mgmtForm',
  className: 'form-horizontal',
  events: {
    'click .submitForm': 'modalAjax',
    'keyup input#videoTags, input#departmentLocations, input#positionTypeName': 'refreshList',
    'click ul#videoTags li, ul#departmentLocations li, ul#positionTypeName li': 'selectTag',
    'click .addTag, .addLocation, .addLot': 'addTag',
    'blur input': 'validateInput',
    'change input[type=\'file\']': 'onFileChange',
    'click .delete-img': 'deleteImg',
    'change select[name=\'statusDesc\']': 'handleChange',
    'click .close': 'displayGrid'
  },
  initialize(opts) {
    const $callTypeTemp = $(`.${this.callType}Temp`);
    _.extend(this, opts);
    this.listenTo(phillips.Events, 'closeModal', this.close);
    this.validInput = true;
    _.bindAll(this, 'render', 'modalAjax');
    this.template = ((this.callType) && ($callTypeTemp.length > 0 && ($callTypeTemp.html() !== ''))) ? _.template($callTypeTemp.html()) : JST.textTpl;
    if (this.hasTabs) {
      if (this.callType === 'add') {
        this.model.set(this.tabsCollectionProperty, new Backbone.Collection(this.tabsModel));
      }
      this.tabsViewCollection = this.model.get(this.tabsCollectionProperty);
    }
    this.listenTo(phillips.Events, 'auctionPurchaseAdd', this.addBtn);
    this.render();
    this.hideGrid();
  },
  addBtn() {
    this.$el.append(`<div class="form-group"><div class="col-md-offset-3 col-md-9"><button type="button" class="submitForm">${this.callType}</button></div></div>`);
  },
  render() {
    const self = this;
    const submitTemp = `<div class="form-group"><div class="col-md-offset-3 col-md-9"><button type="button" class="submitForm">${this.callType === 'edit' ? 'Save' : this.callType}</button><span id="modalResponseMessage" class="hidden"></span><span class="hidden" id="loadingGif"><span class="centered"><img src="/img/ajax-loader.gif"></span></span></div></div>`;
    this.radioTemp = ($('.editRadioTemp').length > 0) ? _.template($('.editRadioTemp').html()) : JST.radioTpl;
    this.selectTemp = ($('.editSelectTemp').length > 0) ? _.template($('.editSelectTemp').html()) : JST.selectTpl;
    this.subTemp = ($('.editOptionTemp').length > 0) ? _.template($('.editOptionTemp').html()) : JST.optionTpl;
    this.deleteTpl = ($('.deleteTemp').length > 0) ? _.template($('.deleteTemp').html()) : JST.deleteTpl;
    switch (this.callType) {
      case 'delete':
        this.$el.append(this[`${this.callType}Tpl`](this.model.attributes));
        return this.$el.append(submitTemp);
      case 'duplicate':
        this.$el.append(JST.duplicateTpl(this.model.attributes));
        return this.$el.append(submitTemp);
      case 'reset':
        this.$el.append(JST.resetTpl(this.model.attributes));
        return this.$el.append(submitTemp);
      default:
        break;
    }
    if (this.ajax === 'videos' && this.callType === 'edit') {
      this.model.url = `${domainURL}/api/Videos/Get/${this.model.get('videoID')}`;
      const prettyPrint = (array, key) => array.reduce((str, item, i) => i + 1 === array.length
        ? `${str}${item[key]}`
        : `${str}${item[key]}, `, '');
      this.model.fetch({
        success: (model) => {
          this.model.set({
            'tagDesc': prettyPrint(model.get('videoTags'), 'tagDesc'),
            'videoLots': new Backbone.Collection(model.get('videoLots'), {
              model: Backbone.Model.extend({
                defaults: {
                  'errorMessage': '',
                  'videoLotID': 0,
                  'saleNumber': '',
                  'lotNumber': '',
                  'tagID': 0,
                  'lotExtension': '',
                  'videoID': 0
                }
              })
            }),
            'videoTags': new Backbone.Collection(model.get('videoTags'), {
              model: Backbone.Model.extend({
                idAttribute: 'tagID',
                defaults: {
                  'errorMessage': '',
                  'createDate': '',
                  'modifyDate': '',
                  'tagDesc': '',
                  'tagID': 0,
                  'tagVideoID': 0,
                  'videoID': 0
                }
              })
            }),
            'publishDate': formatDate(model.get('publishDate'))
          });
        },
        error: (model, response, options) => {
          console.log(model);
          console.log(response);
          console.log(options);
          if (response && response.status && response.status === 401) {
            self.redirectToLogin();
          } else {
            $('#modalFail').find('p').html('There was an error.  Please contact the administrator.');
            $('#modalFail').toggleClass('hidden', false);
          }
        }
      });

    }

    if (this.ajax === 'careers' && this.callType === 'edit') {
      this.model.url = `${domainURL}/api/careers/get?id=${this.model.get('positionId')}`;
      this.model.fetch({
        success(item) {
          item.set({
            'createDate': formatDate(item.get('createDate')),
            'effectiveDate': formatDate(item.get('effectiveDate'))
          });
        },
        error: function (model, response, options) {
          console.log(model);
          console.log(response);
          console.log(options);
          if (response && response.status && response.status === 401) {
            self.redirectToLogin();
          } else {
            $('#modalFail').find('p').html('There was an error.  Please contact the administrator.');
            $('#modalFail').toggleClass('hidden', false);
          }
        }
      });
    }
    this.$el.append(JST.requiredTpl());
    _.forEach(this.collection, function (item, key) {
      if (item.inputType === 'radio') {
        this.$el.append(this.radioTemp(item));
      } else if (item.inputType === 'select') {
        this.$el.append(this.selectTemp(item));
        var modelKeyList = key + 'List';

        var modelKey = key;
        _.forEach(this[modelKeyList], function (item, key) {
          this.$el.find('select[name="' + modelKey + '"]').append(this.subTemp(item));
        }, this);
      } else if (item.inputType === 'textarea') {
        this.textAreaTpl = JST.textareaTpl;
        item.maxLength = _.has(item, 'maxLength') ? item.maxLength : '';
        this.$el.append(this.textAreaTpl(item));
      } else if (item.inputType === 'checkbox') {
        item.value = this.model.get(item.modelKey);
        this.checkboxTemp = _.template($('.' + this.callType + 'CheckboxTemp').html());
        this.$el.append(this.checkboxTemp(item));
      } else if (item.inputType === 'email') {
        item.value = this.model.get(item.modelKey);
        this.checkboxTemp = _.template($('.' + this.callType + 'EmailTemp').html());
        this.$el.append(this.checkboxTemp(item));
      } else if (item.inputType === 'file') {
        this.fileTemplate = _.template($('.' + this.callType + 'FileTemp').html());
        this.$el.append(this.fileTemplate(item));
      } else if (item.inputType === 'image') {
        this.imageTemplate = ($('.editImageTemp').length > 0 && ($('.editImageTemp').html() !== '')) ? _.template($('.editImageTemp').html()) : JST.imageTpl;
        this.$el.append(this.imageTemplate(item));
      } else if (item.inputType === 'hidden') {
        this.hiddenTemplate = _.template($('.' + this.callType + 'HiddenTemp').html());
        this.$el.append(this.hiddenTemplate(item));
      } else if (item.inputType === 'CkeditorCollectionInput') {
        this.collectionInput = new CkeditorCollectionInput(item);
        this.$el.append(this.collectionInput.render());
        this.collectionInput.addCkeditor();
        this.collectionInput.fillInsights();
      } else if (item.inputType === 'CollectionInput') {
        this.collectionInput = new CollectionInput(item);
        this.$el.append(this.collectionInput.render());
      } else if (item.inputType === 'datetime') {
        if ((this.ajax.toLowerCase() !== 'auctionmobility') ||
          (this.ajax.toLowerCase() === 'auctionmobility' &&
            this.model.get('saleType') === 'TimedAuction')) {
          this.$el.append(this.template(item));
          var config = {
            controlType: 'select',
            stepMinute: 15,
            oneLine: true
          };
          if (item.minDate && typeof item.minDate === 'function') {
            config['minDate'] = item.minDate();
          }
          if (item.dateFormat) {
            config['dateFormat'] = item.dateFormat;
          }
          $('#' + item.modelKey).datetimepicker(config);
        }
      } else if (item.inputType === 'date') {
        this.$el.append(this.template(item));
        $('#' + item.modelKey).datepicker();
        // SPECIAL INPUT CASES

        // checkbox within one container
      } else if (item.inputType === 'ckeditor') {
        this.ckeditTemplate = _.template($('.' + this.callType + 'CkeditTemp').html());
        this.$el.append(this.ckeditTemplate(item));
        CKEDITOR.replace(item.modelKey);
        if (item.defaultText && item.defaultText !== '' && typeof item.defaultText === 'string') {
          this.$el.find('textarea[name=\'' + key + '\']').val(item.defaultText);
        }
      } else if (item.inputType === 'tabs') {
        this.$el.append(JST.tabsWrapperTpl(item));
        var tabsView = new TabsView({
          el: '#tabs-group',
          'parentModel': this.model,
          'collection': this.tabsViewCollection,
          'list': item.collection,
          'attr': this.options.attr,
          'parentView': this,
          'callType': this.callType,
          'tabPanesTpl': JST.tabPanesTpl,
          'hasSelect': true,
          'selectList': this.statesList
        });
      } else if (key === 'uploadOptions') {
        this.containerTemp = _.template($('.' + this.callType + 'TagBoxTemp').html());
        this.checkBoxTemp = _.template($('.' + this.callType + 'CheckboxTemp').html());
        item.label = 'Upload Options';
        item.modelKey = key;
        this.$el.append(this.containerTemp(item));
        _.forEach(this.collection[key], function (item, i) {
          this.$el.find('.tagBox#' + key).append(this.checkBoxTemp(item));
        }, this);
      } else if (key === 'customer') {
        this.listenTo(this.model, 'change', function () {
          _.forEach(this.collection[key], function (nestedItem, nestedKey) {
            if (this.model.get('customer') instanceof Backbone.Model) {
              if (nestedKey === 'customerAddresses') {
                _.forEach(this.model.get('customer').get('customerAddresses').models, function (item, i) {
                  _.forEach(nestedItem, function (item, p) {
                    //console.log(item.modelKey);
                    //item.modelKey = item.modelKey + i;
                    this.$el.append(this.template({
                      'modelKey': item.modelKey + i,
                      'label': item.label,
                      'readonly': item.readonly,
                      'inputType': item.inputType
                    }));
                  }, this);
                  _.map(item.attributes, function (value, key) {
                    this.$el.find('input[name=\'' + key + i + '\'], textarea[name=\'' + key + i + '\'], select[name=\'' + key + i + '\']').val(value);
                  }, this);
                }, this);
              } else {
                this.$el.append(this.template(nestedItem));
                _.map(this.model.get('customer').attributes, function (value, key) {
                  if (key === 'phoneNumber') {
                    console.log(this.$el.find('input[name=\'' + key + '\']'));
                    this.$el.find('input[name=\'' + key + '\'], textarea[name=\'' + key + '\'], select[name=\'' + key + '\']').val(value);
                  }
                  ;
                }, this);
              }
            }
          }, this);
        });
        // videoLots has multiple text inputs
      } else if (key === 'videoLots') {
        _.forEach(this.collection.videoLots, function (item, key) {
          this.$el.append(this.template(item));
        }, this);
        // map videoLot value to respective input fields
        if (this.callType === 'edit') {
          this.listenTo(this.model, 'change', function () {
            if (this.model.get('videoLots') instanceof Backbone.Collection) {
              _.forEach(this.model.get('videoLots').models, function (lot, lotKey) {
                _.forEach(this.collection.videoLots, function (item, key) {
                  // item.modelKey is property name
                  this.$el.find('input[name=\'' + item.modelKey + '\'], select[name=\'' + item.modelKey + '\']').val(lot.get(item.modelKey));
                }, this);
              }, this);
            }
          });
        }
        // multiple types of inputs just for videoTags and departmentLocations
      } else if (key === 'videoTags' || key === 'departmentLocations') {
        this.inputListTemp = _.template($('.' + this.callType + 'InputListTemp').html());
        this.dataListTemp = _.template($('.' + this.callType + 'DataListTemp').html());
        this.badgeBoxTemp = _.template($('.' + this.callType + 'TagBoxTemp').html());
        this.badgeTemp = _.template($('.' + this.callType + 'TagBadgeTemp').html());
        if (this.callType === 'edit') {
          // CLEAN UP CODE:  REFACTOR ASAP.  RENAME CLASSES TO BE MORE MODULAR OR ALLOW PARAMETERS WORK FOR BOTH VIDEOTAGS AND DEPARTMENTLOCATIONS
          if (this.ajax === 'videos') {
            this.listenTo(this.model, 'change', function () {
              if (this.model.get('videoTags') instanceof Backbone.Collection) {
                _.forEach(this.collection[key], function (item, key) {
                  switch (item.inputType) {
                    case 'inputList':
                      this.$el.append(this.inputListTemp(item));
                      break;
                    case 'dataList':
                      this.$el.find('input[name=\'' + item.modelKey + '\']').after(this.dataListTemp(item));
                      _.forEach(this.tagsList, function (item, key) {
                        this.dataListItemTemp = _.template($('.' + this.callType + 'DataListItemTemp').html());
                        this.$el.find('ul#videoTags').append(this.dataListItemTemp(item));
                      }, this);
                      break;
                    case 'div':
                      var badgeDesc,
                        label = '';

                      if (item.modelKey === 'videoLots') {
                        badgeDesc = 'lotNumber',
                          label = 'lots';
                      } else if (item.modelKey === 'videoTags') {
                        badgeDesc = 'tagDesc',
                          label = 'tags';
                      }
                      this.setupVideoBox(item.modelKey, badgeDesc, label);
                      break;
                    default:
                      break;
                  }
                }, this);
              }
            });
          } else {
            _.forEach(this.collection[key], function (item, key) {
              switch (item.inputType) {
                case 'text':
                  this.$el.append(this.template(item));
                  break;
                case 'inputList':
                  this.$el.append(this.inputListTemp(item));
                  break;
                case 'dataList':
                  this.$el.find('input[name=\'' + item.modelKey + '\']').after(this.dataListTemp(item));
                  _.forEach(this.tagsList, function (item, key) {
                    this.dataListItemTemp = _.template($('.' + this.callType + 'DataListItemTemp').html());
                    this.$el.find('ul#departmentLocations').append(this.dataListItemTemp(item));
                  }, this);
                  break;
                case 'div':
                  var badgeDesc,
                    label = '';
                  if (item.modelKey === 'departmentLocations') {
                    badgeDesc = 'location',
                      label = 'locations';
                  }
                  this.setupVideoBox(item.modelKey, badgeDesc, label);
                  break;
                case 'divWrapper':
                  this.wrapperTpl = _.template($('.wrapperTpl').html());
                  this.$el.append(this.wrapperTpl(item));
                  var inputLabels = ['Email', 'Phone'];
                  this.setupEditTags(this.model.get('departmentLocations'), inputLabels);
                  break;
                default:
                  break;
              }
            }, this);
          }
        } else {
          if (this.ajax === 'videos') {
            _.forEach(this.collection[key], function (arrItem, arrKey) {
              switch (arrItem.inputType) {
                case 'text':
                  this.$el.append(this.template(arrItem));
                  break;
                case 'inputList':
                  this.$el.append(this.inputListTemp(arrItem));
                  break;
                case 'dataList':
                  this.$el.find('input[name=\'' + arrItem.modelKey + '\']').after(this.dataListTemp(arrItem));
                  _.forEach(this.tagsList, function (tag, key) {
                    this.dataListItemTemp = _.template($('.' + this.callType + 'DataListItemTemp').html());
                    this.$el.find(`ul#${key}`).append(this.dataListItemTemp(tag));
                  }, this);
                  break;
                case 'div':
                  var badgeDesc,
                    label = '';

                  if (arrItem.modelKey === 'videoLots') {
                    badgeDesc = 'lotNumber',
                      label = 'lots';
                  } else if (arrItem.modelKey === 'videoTags') {
                    badgeDesc = 'tagDesc',
                      label = 'tags';
                  } else if (arrItem.modelKey === 'departmentLocations') {
                    badgeDesc = 'location',
                      label = 'locations';
                  }
                  this.setupVideoBox(arrItem.modelKey, badgeDesc, label);
                  break;
                default:
                  break;
              }
            }, this);
          } else if (this.ajax === 'departments') {
            _.forEach(this.collection[key], (arrItem, key) => {
              switch (arrItem.inputType) {
                case 'text':
                  this.$el.append(this.template(arrItem));
                  break;
                case 'inputList':
                  this.$el.append(this.inputListTemp(arrItem));
                  break;
                case 'dataList':
                  this.$('input[name=\'' + arrItem.modelKey + '\']').after(this.dataListTemp(arrItem));
                  _.forEach(this.tagsList, (tag, key) => {
                    this.dataListItemTemp = _.template($('.' + this.callType + 'DataListItemTemp').html());
                    this.$(`ul#${key}`).append(this.dataListItemTemp(tag));
                  });
                  break;
                case 'div':
                  var badgeDesc,
                    label = '';
                  if (item.modelKey === 'departmentLocations') {
                    badgeDesc = 'location',
                      label = 'locations';
                  }
                  this.setupVideoBox(item.modelKey, badgeDesc, label);
                  break;
                case 'divWrapper':
                  this.wrapperTpl = _.template($('.wrapperTpl').html());
                  this.$el.append(this.wrapperTpl(item));
                  break;
                default:
                  break;
              }
            });
          }
        }
      } else if (item.inputType === 'autoComplete') {
        this.autoCompleteTemp = _.template($('.autoCompleteTemp').html());
        this.dataListItemTemp = _.template($('.' + this.callType + 'DataListItemTemp').html());
        this.$el.append(this.autoCompleteTemp(item));
        var modelKeyList = key + 'List';

        var modelKey = key;
        _.forEach(this[modelKeyList], function (item, key) {
          this.$el.find('ul[name="' + modelKey + '"]').append(this.dataListItemTemp(item));
        }, this);
      }
      // last not but least, regular text input
      else {
        //awfull hack to stop the auctionduration from rendering - by cristian suarez
        if ((item.modelKey.toLowerCase() !== 'auctionduration') ||
          (this.ajax.toLowerCase() === 'auctionmobility' &&
            this.model.get('saleType') !== 'TimedAuction')
        ) {
          this.$el.append(this.template(item));
        }
      }
    }, this);
    if (this.callType === 'edit' || (this.callType === 'add' && this.ajax === 'videos')) {
      var modelAttributes = this.model.attributes,
        inputType;
      _.map(this.model.attributes, function (value, key) {
        //if (this.collection[key] !== undefined) {
        //  inputType = this.collection[key].inputType;
        //};
        for (var p in this.collection) {
          if (!Array.isArray(this.collection[p])) {
            if (this.collection[p].modelKey === key) {
              inputType = this.collection[p].inputType;
              if (inputType === 'radio') {
                this.$el.find('input[name=\'' + key + '\'][value=\'' + value + '\']').prop('checked', true);
              } else if (inputType === 'image') {
                var baseSrcUrl = this.collection[p].baseSrcUrl,
                  imgSrc = baseSrcUrl + value;
                this.$('img[class=\'' + key + '\']').prop('src', baseSrcUrl + value);
                if (imgSrc.length < 1) {
                  this.$('a[name=\'' + key + '\']').addClass('hidden');
                }
              } else if ((this.ajax === 'teamMembers' && key === 'departmentCode') || key === 'uploadOptions' || key === '') {
              } else if ((key === 'departmentName' && this.ajax !== 'departments') || (this.ajax === 'teamMembers' && key === 'locationName') || key === 'teamMemberTypeDesc' || key === 'statusDesc') {
                this.$el.find('select[name=\'' + key + '\']').children('option[name=\'' + value + '\']').prop('selected', true);
                if (value === 'calendar_only') {
                  this.toggleShow(value, $('#uploadOptions').parent('.form-group'));
                }
              } else if ((this.ajax === 'careers' && key === 'isActive')) {
                this.$el.find('input[name=\'' + key + '\']').prop('checked', value);
              } else if (inputType === 'date') {
                if (value) {
                  var date = new Date(value);
                  var dateString = (date.getUTCMonth() + 1) + '/' + date.getUTCDate() + '/' + date.getUTCFullYear();//'mm/dd/yy'
                  this.$el.find('input[name=\'' + key + '\'], textarea[name=\'' + key + '\'], select[name=\'' + key + '\']').val(dateString);
                }

              } else if (inputType === 'datetime') {
                if (value) {
                  if (this.ajax.toLowerCase() !== 'auctionmobility' ||
                    (this.ajax.toLowerCase() === 'auctionmobility' && modelAttributes.saleType == 'TimedAuction')) {
                    this.$el.find('input[name=\'' + key + '\'], textarea[name=\'' + key + '\'], select[name=\'' + key + '\']').val(value);
                    if (this.collection[p].minDate && typeof this.collection[p].minDate === 'function') {
                      var minDate = this.collection[p].minDate(modelAttributes);
                      $('#' + key).datetimepicker('option', 'minDate', minDate);
                    }
                  }
                }
              } else if (inputType === 'file' && this.ajax === 'careers') {
                if (value) {
                  //create download pdf anchor
                  var pdfDownload = _.template($('.pdfDownload').html());
                  this.$el.find('div[id=\'pdfFileDownload\']').append(pdfDownload({ value: value }));
                }
              } else {
                if (inputType !== 'file') {
                  this.$el.find('input[name=\'' + key + '\'], textarea[name=\'' + key + '\'], select[name=\'' + key + '\']').val(value);
                }
              }
              if (this.collection[p].dependsOn) {
                var hasPDFSource = this.model.attributes[this.collection[p].dependsOn];
                if (hasPDFSource === '') {
                  $('#' + this.collection[p].modelKey).hide();
                }
              }
            }
          }
        }
      }, this);
    }
    if (this.ajax === 'videos' && this.callType === 'edit') {
      this.listenTo(phillips.Events, 'showTags', () => {
        this.$el.append(submitTemp);
      });
    } else {
      if (this.callType === 'edit') {
        this.$el.append(submitTemp);
      } else {
        if (this.ajax !== 'auctionPurchase') {
          this.$el.append(submitTemp);
        }
      }
    }
    return this;
  },
  refreshList(e) {
    var value = $(e.target).val();
    // adds a :Contains() (note the uppercase) option to selectors
    // that does the same as :contains(), but it converts all text to uppercase,
    // and then compares them.
    $.expr[':'].Contains = function (a, i, m) {
      return (a.textContent || a.innerText || '').toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
    };
    // function toTitleCase(str) {
    //     return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    // }
    // var capitalized = toTitleCase(value);
    $('ul#videoTags, ul#departmentLocations, ul#positionTypeName').find('li:not(:Contains(' + value + '))').hide();
    $('ul#videoTags, ul#departmentLocations, ul#positionTypeName').find('li:Contains(' + value + ')').show();
  },
  parseForm(formArray, dataObj) {
    var data = (dataObj) ? dataObj : {};
    _.each(formArray, (input) => {
      if (input.name === 'startDate' || input.name === 'endDate') {
        if (input.value === 'January 1 0001 00:00' || input.value === 'January 1 0001 00:00') {
          data[input.name] = null;
        } else {
          data[input.name] = input.value;
        }
      } else if (input.name === 'collectionInput') {
        data[input.value] = this.collectionInput.getValue();
      } else {
        data[input.name] = input.value;
      }
    });
    // console.log('data', data);
    return data;
  },
  deleteImg(e) {
    var prop = $(e.target).attr('name');
    this.model.set(prop, '');
    this.$('img[class=' + prop + ']').attr('src', '');
    $(e.target).addClass('hidden');
  },
  modalAjax(e) {
    e.preventDefault();
    const self = this;
    const $form = $(e.target).parents('form');
    this.$('#loadingGif').toggleClass('hidden');
    switch (this.ajax) {
      case 'auctionMobility':
        switch (this.callType) {
          case 'edit':
            let duration;
            let bidThreshold = parseInt($('input[name=\'bidThreshold\']').val(), 10);
            let auctionDuration = parseInt($('input[name=\'auctionDuration\']').val(), 10);
            if ($('input[name=\'saleType\']').val() === 'TimedAuction') {
              var eventDateStr = $('input[name=\'eventDateAsDate\']').val();
              var endDateStr = $('input[name=\'endDate\']').val();
              var eventDate = new Date(eventDateStr);
              var endDate = new Date(endDateStr);
              duration = Math.floor(Math.abs(eventDate - endDate) / 3600000);
            }
            if ($('input[name=\'bidThreshold\']').val() === '' || $('input[name=\'bidThreshold\']').val() % 1 !== 0 || isNaN($('input[name=\'bidThreshold\']').val() % 1)) {
              if (typeof bidThreshold === 'undefined') {
                $('.field-validation-valid[data-valmsg-for=\'bidThreshold\']').html('Bid Threshold is required and must be an integer.');
                return false;
              }
            }
            if ($('input[name=\'auctionDuration\']').val() === '' || $('input[name=\'auctionDuration\']').val() % 1 !== 0 || isNaN($('input[name=\'auctionDuration\']').val() % 1)) {
              if (typeof duration === 'undefined') {
                $('.field-validation-valid[data-valmsg-for=\'auctionDuration\']').html('Duration is required and must be an integer.');
                return false;
              }
            }
            if (typeof duration !== 'undefined') {
              auctionDuration = duration;
            }
            var jsonOfLog = `SaleNo=${$('input#saleNumber').val()}&CalendarID=${$('input#calendarID').val()}&IncludeAuctionImage=${$('input#IncAuctionImage').is(':checked')}&IncludeLotImages=${$('input#IncLotImages').is(':checked')}&IncludeLots=${$('input#IncLotInfo').is(':checked')}&PublicationStatus=${$('select[name=\'statusDesc\']').val()}&Duration=${auctionDuration}&BidThreshold=${bidThreshold}`;
            $.ajax({
              type: 'GET',
              dataType: 'text',
              url: `${domainURL}/api/AuctionMobilityAuctions/GetUpsertAuction`,
              data: jsonOfLog,
              success: (returnPayload) => {
                switch (returnPayload) {
                  case '"Success!"':

                    $('#modalSuccess').find('p').html('Success!: Sale ' + this.model.get('saleNumber') + ' was uploaded successfully.');
                    $('#modalSuccess').toggleClass('hide', false);
                    phillips.Events.trigger('editTeamOrder');
                    break;
                  case '"Failure!"':
                    $('#modalFail').find('p').html('There was an error updating Auction Mobility.  Please contact the administrator.');
                    $('#modalFail').toggleClass('hide', false);
                    break;
                  default:
                    break;
                }
              },
              error: (xhr, ajaxOptions, thrownError) => {
                $('#modalFail').find('p').html('There was an error updating Auction Mobility.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
              },
              complete: () => {
                this.$('#loadingGif').toggleClass('hidden');
              },
              processData: false
            });
            break;
          case 'reset':
            var saleNumber = this.model.get('saleNumber');
            var putAMStatusUrl = `${domainURL}/api/AuctionMobilityAuctions/PutResetAuctionMobilityStatus?SaleNumber=${saleNumber}`;
            $.ajax({
              type: 'PUT',
              url: putAMStatusUrl,
              success: (returnPayload, status, options) => {
                $('#modalSuccess').find('p').html(`Success!: Sale ${self.model.get('saleNumber')} was reset successfully.`);
                $('#modalSuccess').toggleClass('hide', false);
                phillips.Events.trigger('editTeamOrder');
              },
              error: (xhr, ajaxOptions, thrownError) => {
                $('#modalFail').find('p').html('There was an error resetting the sale.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
                console.log('error: ', xhr, ajaxOptions, thrownError);
              },
              complete: () => {
                this.$('#loadingGif').toggleClass('hidden', false);
              }
            });
            break;
          default:
            break;
        }
        break;
      case 'auctionMobilityRegister':
        switch (this.options.callType) {
          case 'edit':
            self.model.url = domainURL + '/api/AuctionMobilityRegistrations/Put';
            self.model.save(
              {
                'userID': self.model.get('id'),
                'registrationRowID': self.model.get('registrationRowID'),
                'customerRowID': self.model.get('customerRowID'),
                'accountNumber': $('input[name=\'accountNumber\']').val(),
                'paddle': $('input[name=\'paddle\']').val(),
                'registrationStatusID': $('select[name=\'registrationStatusID\']').val()
              },
              {
                success: function (model) {
                  switch (model.get('errorMessage')) {
                    case 'Success':
                      $('#modalSuccess').find('p').html('Success!: User registration was uploaded successfully.');
                      $('#modalSuccess').toggleClass('hide', false);
                      break;
                    default:
                      $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                      self.set(model.previousAttributes());
                      break;
                  }
                },
                error: function (model, response, options) {
                  $('#modalFail').find('p').html(response.responseJSON.message + ' ' + response.responseJSON.exceptionMessage);
                  $('#modalFail').toggleClass('hide', false);
                },
                complete: (xhr, status) => {
                  this.$('#loadingGif').toggleClass('hidden');
                },
                wait: true
              });
            break;
          default:
            break;
        }
        break;
      case 'teamMembers':
        switch (this.callType) {
          case 'add':
            uploadTeamMemberImage({
              email: $("input[name='email']").val(),
              currentEmail: $("input[name='currentEmail']").val(),
              fileContainer: document.getElementById('teamMemberImage')
            })
              .done((data) => {
                self.model.url = domainURL + '/api/TeamMembers/Post';
                self.model.save(
                  {
                    'errorMessage': '',
                    'teamMemberID': 0,
                    'teamMemberTypeID': $('select[name=\'teamMemberTypeDesc\']').val(),
                    'teamMemberTypeDesc': $('select[name=\'teamMemberTypeDesc\']').children('option').filter(':selected').text(),
                    'departmentID': $('select[name=\'departmentName\']').val(),
                    'departmentName': $('select[name=\'departmentName\']').children('option').filter(':selected').text(),
                    'departmentSelect': $('select[name=\'departmentName\']').children('option').filter(':selected').text(),
                    'locationID': $('select[name=\'locationName\']').val(),
                    'locationName': $('select[name=\'locationName\']').children('option').filter(':selected').text(),
                    'title': $('input[name=\'title\']').val(),
                    'firstName': $('input[name=\'firstName\']').val(),
                    'lastName': $('input[name=\'lastName\']').val(),
                    'email': $('input[name=\'email\']').val(),
                    'phone': $('input[name=\'phone\']').val(),
                    'imageURL': data ? data : '',
                    'teamDisplayOrder': $('input[name=\'teamDisplayOrder\']').val(),
                    'isTeamDisplay': $('input[name=\'isTeamDisplay\']:checked').val(),
                    'isLocationDisplay': $('input[name=\'isLocationDisplay\']:checked').val(),
                    'isActive': $('input[name=\'isActive\']:checked').val(),
                    'displayEmail': $('input[name=\'displayEmail\']:checked').val()
                  },
                  {
                    success: (model, response, options) => {
                      switch (model.get('errorMessage')) {
                        case 'Success':
                          $('#modalSuccess').find('p').html(`Success!: ${self.model.get('firstName')} ${self.model.get('lastName')} was added successfully.`);
                          $('#modalSuccess').toggleClass('hide', false);
                          this.model.set({
                            'id': this.model.get('teamMemberID'),
                            'imageURL': model.get('imageURL'),
                            'edit': `<a class='edit-btn' id='edit' data-toggle='modal' data-target='#myModal' data-id='${self.model.get('teamMemberID')}'>Edit</a>`,
                            'teamMemberDelete': `<a class='edit-btn' id='delete' data-toggle='modal' data-target='#myModal' data-id='${self.model.get('teamMemberID')}'>Delete</a>`
                          });
                          phillips.Events.trigger('addModel', self.model);
                          phillips.Events.trigger('editTeamOrder');
                          break;
                        default:
                          $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                          $('#modalFail').toggleClass('hide', false);
                          self.model.set(model.previousAttributes());
                          break;
                      }
                    },
                    error: (model, response, options) => {
                      $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                    },
                    complete: (xhr, status) => {
                      this.$('#loadingGif').toggleClass('hidden');
                    },
                    wait: true
                  }
                );
              })
              .fail(() => {
                this.$('#loadingGif').toggleClass('hidden');
                $('#modalFail').find('p').html('There was an error the team member image.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
              });
            break;
          case 'edit':
            uploadTeamMemberImage({
              email: $("input[name='email']").val(),
              currentEmail: $("input[name='currentEmail']").val(),
              fileContainer: document.getElementById('teamMemberImage')
            })
              .done((data) => {
                this.model.url = domainURL + '/api/TeamMembers/Put';
                this.model.save(
                  {
                    'teamMemberID': self.model.get('teamMemberID'),
                    'deleteImage': $('input[name=\'deleteImage\']:checked').val(),
                    'teamMemberTypeID': $('select[name=\'teamMemberTypeDesc\']').val(),
                    'teamMemberTypeDesc': $('select[name=\'teamMemberTypeDesc\']').children('option').filter(':selected').text(),
                    'departmentID': $('select[name=\'departmentName\']').val(),
                    'departmentName': $('select[name=\'departmentName\']').children('option').filter(':selected').text(),
                    'departmentSelect': $('select[name=\'departmentName\']').children('option').filter(':selected').text(),
                    'locationID': $('select[name=\'locationName\']').val(),
                    'locationName': $('select[name=\'locationName\']').children('option').filter(':selected').text(),
                    'title': $('input[name=\'title\']').val(),
                    'firstName': $('input[name=\'firstName\']').val(),
                    'lastName': $('input[name=\'lastName\']').val(),
                    'email': $('input[name=\'email\']').val(),
                    'phone': $('input[name=\'phone\']').val(),
                    'imageURL': data ? data : self.model.get('imageURL'),
                    'teamDisplayOrder': $('input[name=\'teamDisplayOrder\']').val(),
                    'isTeamDisplay': $('input[name=\'isTeamDisplay\']:checked').val(),
                    'isLocationDisplay': $('input[name=\'isLocationDisplay\']:checked').val(),
                    'isActive': $('input[name=\'isActive\']:checked').val(),
                    'displayEmail': $('input[name=\'displayEmail\']:checked').val()
                  },
                  {
                    success: (model, response) => {
                      switch (model.get('errorMessage')) {
                        case 'Success':
                          phillips.Events.trigger('editTeamOrder');
                          $('#modalSuccess').find('p').html(`Success!  ${this.model.get('firstName')} ${this.model.get('lastName')} was updated successfully.`);
                          $('#modalSuccess').toggleClass('hide', false);
                          break;
                        default:
                          $('#modalFail').find('p').html('There was an error updating the team member.  Please contact the administrator.');
                          $('#modalFail').toggleClass('hide', false);
                          self.model.set(model.previousAttributes());
                          break;
                      }
                    },
                    error: (model, response, options) => {
                      $('#modalFail').find('p').html('There was an error updating the team member.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                      console.log(model);
                      console.log(response);
                      console.log(options);
                    },
                    complete: (xhr, status) => {
                      this.$('#loadingGif').toggleClass('hidden');
                    },
                    wait: true
                  }
                );
              })
              .fail(() => {
                this.$('#loadingGif').toggleClass('hidden');
                $('#modalFail').find('p').html('There was an error the team member image.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
              });
            break;
          case 'delete':
            this.model.url = domainURL + '/api/TeamMembers/Delete';
            var sendData = {
              teamMemberID: self.model.get('teamMemberID'),
              email: self.model.get('email')
            };
            this.model.destroy({
              data: JSON.stringify(sendData),
              contentType: 'application/json',
              success: (model, response) => {
                this.$('#loadingGif').toggleClass('hidden');
                switch (response.errorMessage) {
                  case 'Success':
                    $('#modalSuccess').find('p').html('The user has been deleted.');
                    $('#modalSuccess').toggleClass('hide', false);
                    break;
                  default:
                    $('#modalFail').find('p').html('There was an error deleting the user.  Please contact the administrator.');
                    $('#modalFail').toggleClass('hide', false);
                    break;
                }
              },
              error: () => {
                $('#modalFail').find('p').html('There was an error.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
              },
              complete: () => {
                this.$('#loadingGif').toggleClass('hidden');
              }
            });
            break;
          case 'changePW':
            break;
          default:
            break;
        }
        break;
      case 'videos':
        const $sortOrder = $('input[name=\'sortOrder\']');
        // validate sort order is not blank or 0
        if ($sortOrder.val() === '' || $sortOrder.val() === '0') {
          $('.field-validation-valid[data-valmsg-for=\'sortOrder\']').html('Please enter a value higher than 0.');
          this.$('#loadingGif').toggleClass('hidden');
          return false;
        }
        switch (this.callType) {
          case 'add':
            uploadVideoThumbnail()
              .then((data) => {
                let imagesource = $('input[name=\'imageSource\']').val();
                let deptId = $('select[name=\'departmentName\']').val() == '0' ? null : $('select[name=\'departmentName\']').val();
                if (data) {
                  imagesource = data;
                }
                this.model.get('videoLots').add({
                  'errorMessage': '',
                  'videoLotID': 0,
                  'videoID': self.model.get('videoID'),
                  'saleNumber': $('input[name=\'saleNumber\']').val(),
                  'lotNumber': $('input[name=\'lotNumber\']').val(),
                  'lotExtension': $('input[name=\'lotExtension\']').val().trim().substr(0, 1)
                });
                this.model.url = domainURL + '/api/Videos/Post';
                this.model.save(
                  {
                    'errorMessage': '',
                    'videoID': 0,
                    'title': $('input[name=\'title\']').val(),
                    'description': $('textarea[name=\'description\']').val(),
                    'shortDescription': $('textarea[name=\'shortDescription\']').val(),
                    'publishDate': convertDate($('input[name=\'publishDate\']').val()),
                    'departmentId': deptId,
                    'source': $('input[name=\'source\']').val(),
                    'imageSource': imagesource,
                    'sortOrder': $('input[name=\'sortOrder\']').val(),
                    // "useShortDesc": true,
                    'useLotImage': $('input[name=\'useLotImage\']:checked').val(),
                    'videoLots': self.model.get('videoLots'),
                    'videoTags': self.model.get('videoTags'),
                    'isFeature': $('input[name=\'isFeature\']:checked').val(),
                    'isLive': $('input[name=\'isLive\']:checked').val(),
                    'aboveTheFold': $('input[name=\'aboveTheFold\']:checked').val(),
                    'squareAspectRatio': $('input[name=\'squareAspectRatio\']:checked').val()
                  },
                  {
                    success: (model, response, options) => {
                      switch (model.get('errorMessage')) {
                        case 'Success':
                          $('#modalSuccess').find('p').html('Success!: ' + self.model.get('title') + ' was uploaded successfully.');
                          phillips.Events.trigger('editTeamOrder');
                          $('#modalSuccess').toggleClass('hidden', false);
                          this.model.set({
                            'id': model.get('videoID'),
                            'edit': '<a class=\'edit-btn\' id=\'edit\' data-toggle=\'modal\' data-target=\'#myModal\' data-id=\'' + model.get('videoID') + '\'>Edit</a>',
                            'delete': '<a class=\'edit-btn\' id=\'delete\' data-toggle=\'modal\' data-target=\'#myModal\' data-id=\'' + model.get('videoID') + '\'>Delete</a>'
                          });
                          phillips.Events.trigger('addModel', self.model);
                          break;
                        default:
                          $('#modalFail').find('p').html(`There was an error updating the video. <p><b>${model.get('errorMessage')}.</b></p> Please contact the administrator.`);
                          $('#modalFail').toggleClass('hidden', false);
                          this.model.set(model.previousAttributes());
                          console.log(model);
                          console.log(response);
                          console.log(options);
                          break;
                      }
                    },
                    error: (model, response, options) => {
                      if (response && response.status && response.status === 401) {
                        self.redirectToLogin();
                      } else {
                        $('#modalFail').find('p').html('There was an error updating the video.  Please contact the administrator.');
                        $('#modalFail').toggleClass('hidden', false);
                      }
                      console.log(model);
                      console.log(response);
                      console.log(options);
                    },
                    complete: () => {
                      this.$('#loadingGif').toggleClass('hidden');
                    },
                    wait: true
                  }
                );
              })
              .fail(function () {
                $('#modalFail').find('p').html('There was an error uploading the image thumbnail. Please contact the administrator.');
                $('#modalFail').toggleClass('hidden', false);
                this.$('#loadingGif').toggleClass('hidden');
              });
            break;
          case 'edit':
            const lotCol = self.model.get('videoLots');
            let vidLotID;
            if (lotCol.length !== 0) {
              if (lotCol.at(0).get('videoLotID') !== undefined) {
                vidLotID = lotCol.at(0).get('videoLotID');
              } else {
                vidLotID = 0;
              }
              lotCol.at(0).set({
                'saleNumber': $('input[name=\'saleNumber\']').val(),
                'videoID': self.model.get('videoID'),
                'videoLotID': vidLotID,
                'lotNumber': $('input[name=\'lotNumber\']').val(),
                'lotExtension': $('input[name=\'lotExtension\']').val().trim().substr(0, 1)
              });
            } else {
              lotCol.add({
                'errorMessage': '',
                'saleNumber': $('input[name=\'saleNumber\']').val(),
                'videoID': self.model.get('videoID'),
                'videoLotID': 0,
                'lotNumber': $('input[name=\'lotNumber\']').val(),
                'lotExtension': $('input[name=\'lotExtension\']').val().trim().substr(0, 1)
              });
            }
            uploadVideoThumbnail()
              .done((data) => {
                let imagesource = $('input[name=\'imageSource\']').val();
                if (data) {
                  imagesource = data;
                }
                let deptId = $('select[name=\'departmentName\']').val() == '0' ? null : $('select[name=\'departmentName\']').val();
                this.model.url = domainURL + '/api/Videos/Put';
                this.model.save(
                  {
                    'videoID': self.model.get('videoID'),
                    'deleteImage': $('input[name=\'deleteImage\']:checked').val(),
                    'title': $('input[name=\'title\']').val(),
                    'description': $('textarea[name=\'description\']').val(),
                    'shortDescription': $('textarea[name=\'shortDescription\']').val(),
                    'source': $('input[name=\'source\']').val(),
                    'imageSource': imagesource,
                    'departmentId': deptId,
                    'sortOrder': $('input[name=\'sortOrder\']').val(),
                    'publishDate': convertDate($('input[name=\'publishDate\']').val()),
                    'year': self.model.get('year'),
                    'useShortDesc': self.model.get('useShortDesc'),
                    'useLotImage': $('input[name=\'useLotImage\']:checked').val(),
                    'videoLots': self.model.get('videoLots'),
                    'videoTags': self.model.get('videoTags'),
                    'isFeature': $('input[name=\'isFeature\']:checked').val(),
                    'isLive': $('input[name=\'isLive\']:checked').val(),
                    'aboveTheFold': $('input[name=\'aboveTheFold\']:checked').val(),
                    'squareAspectRatio': $('input[name=\'squareAspectRatio\']:checked').val()
                  },
                  {
                    success: (model, response, options) => {
                      switch (model.get('errorMessage')) {
                        case 'Success':
                          phillips.Events.trigger('editTeamOrder');
                          $('#modalSuccess').find('p').html('Success!  ' + self.model.get('title') + ' was uploaded successfully.');
                          $('#modalSuccess').toggleClass('hidden', false);
                          break;
                        default:
                          $('#modalFail').find('p').html(`There was an error updating the video. <p><b>${model.get('errorMessage')}.</b></p> Please contact the administrator.`);
                          $('#modalFail').toggleClass('hidden', false);
                          console.log('false success ', response);
                          this.model.set(self.model.previousAttributes());
                          break;
                      }
                    },
                    error: (model, response, options) => {
                      if (response && response.status && response.status === 401) {
                        self.redirectToLogin();
                      } else {
                        $('#modalFail').find('p').html('There was an error updating the video.  Please contact the administrator.');
                        $('#modalFail').toggleClass('hidden', false);
                      }
                      console.log(model);
                      console.log(response);
                      console.log(options);
                    },
                    complete: (xhr, status) => {
                      this.$('#loadingGif').toggleClass('hidden');
                    },
                    wait: true
                  }
                );
              })
              .fail(() => {
                this.$('#loadingGif').toggleClass('hidden');
                $('#modalFail').find('p').html('There was an error uploading the image thumbnail. Please contact the administrator.');
                $('#modalFail').toggleClass('hidden', false);
              });
            break;
          case 'delete':
            this.model.url = domainURL + '/api/Videos/Delete';
            const sendData = {
              'videoID': this.model.get('videoID'),
              'title': this.model.get('videoID'),
              'description': this.model.get('videoID'),
              'shortDescription': this.model.get('videoID'),
              'source': this.model.get('source'),
              'imageSource': this.model.get('imageSource'),
              'sortOrder': this.model.get('sortOrder'),
              'publishDate': this.model.get('publishDate'),
              'year': this.model.get('year'),
              'useShortDesc': this.model.get('useShortDesc'),
              'useLotImage': this.model.get('useLotImage'),
              'videoLots': this.model.get('videoLots'),
              'videoTags': this.model.get('videoTags'),
              'isFeatured': this.model.get('isFeatured'),
              'isLive': this.model.get('isLive')
            };
            this.model.destroy({
              data: JSON.stringify(sendData),
              contentType: 'application/json',
              success: (model, response) => {
                switch (response.errorMessage) {
                  case 'Success':
                    $('#modalSuccess').find('p').html('The video has been deleted.');
                    $('#modalSuccess').toggleClass('hidden', false);
                    break;
                  default:
                    $('#modalFail').find('p').html('There was an error deleting the video.  Please contact the administrator.');
                    $('#modalFail').toggleClass('hidden', false);
                    break;
                }
              },
              error: (model, response, options) => {
                if (response && response.status && response.status === 401) {
                  self.redirectToLogin();
                } else {
                  $('#modalFail').find('p').html('There was an error.  Please contact the administrator.');
                  $('#modalFail').toggleClass('hidden', false);
                }
              },
              complete: (xhr, status) => {
                this.$('#loadingGif').toggleClass('hidden');
              }
            });
            break;
          default:
            break;
        }
        break;
      case 'departments':
        var deptLocations = this.model.get('departmentLocations');
        let url = {
          'add': `${domainURL}/api/Departments/Post`,
          'edit': `${domainURL}/api/Departments/Put`,
          'delete': `${domainURL}/api/Departments/Delete`
        };
        this.model.url = url[this.callType];
        _.forEach(deptLocations.models, (dept, i) => {
          dept.set({
            'departmentID': dept.get('location').get('departmentID'),
            'locationID': dept.get('location').get('locationID')
          });
          _.forEach(dept.get('departmentLocationCommunications').models, (loc) => {
            loc.get('communication').set({
              'communicationDesc': $('input[name=\'locationEmail' + i + '\']').val()
            });
          });
        });
        this.model.submitForm({
          'errorMessage': '',
          'departmentDisplayName': $('input[name=\'departmentDisplayName\']').val(),
          'departmentDesc': CKEDITOR.instances.departmentDesc.getData(),
          'departmentImgURL': $('input[name=\'departmentImgURL\']').val(),
          'departmentCode': $('input[name=\'departmentCode\']').val(),
          'departmentTypeID': $('select[name=\'departmentTypeID\']').val(),
          'departmentName': $('input[name=\'departmentName\']').val(),
          'displayOrder': $('input[name=\'displayOrder\']').val(),
          'isActive': $('input[name=\'isActive\']:checked').val(),
          'isDisplay': $('input[name=\'isDisplay\']:checked').val(),
          'isImageOverride': $('input[name=\'isImageOverride\']:checked').val(),
          'hasCatalogueSubscription': $('input[name=\'hasCatalogueSubscription\']:checked').val(),
        })
          .done((model, response, options) => {
            switch (model.get('errorMessage')) {
              case 'Success':
                $('#modalSuccess').find('p').html(`Success!: ${model.get('departmentName')} was uploaded successfully.`);
                $('#modalSuccess').toggleClass('hidden', false);
                phillips.Events.trigger('updateCollection');
                break;
              default:
                $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                $('#modalFail').toggleClass('hidden', false);
                this.model.set(this.model.previousAttributes());
                break;
            }
          })
          .fail((model, response, options) => {
            $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
            $('#modalFail').toggleClass('hidden', false);
          })
          .always(() => {
            this.$('#loadingGif').toggleClass('hidden');
          });

        break;
      case 'locations':
        switch (this.callType) {
          case 'add':
            self.model.url = domainURL + '/api/Locations/Post';
            self.model.save(
              {
                'locationName': $('input[name=\'locationName\']').val(),
                'locationDesc': $('textarea[name=\'locationDesc\']').val(),
                'locationTypeID': 1,
                'displayOrder': $('input[name=\'displayOrder\']').val(),
                'locationPhone': $('input[name=\'locationPhone\']').val(),
                'locationEmail': $('input[name=\'locationEmail\']').val(),
                'locationImgURL': $('input[name=\'locationImgURL\']').val(),
                'officeHours': $('input[name=\'officeHours\']').val(),
                'galleryHours': $('input[name=\'galleryHours\']').val(),
                'isRegional': $('input[name=\'isRegional\']:checked').val(),
                'isDisplay': $('input[name=\'isDisplay\']:checked').val(),
                'isActive': $('input[name=\'isActive\']:checked').val()

              },
              {
                success: function (model, response, options) {
                  switch (model.get('errorMessage')) {
                    case 'Success':
                      $('#modalSuccess').find('p').html('Success!  ' + self.model.get('locationName') + ' was added successfully.');
                      $('#modalSuccess').toggleClass('hide', false);
                      phillips.Events.trigger('editTeamOrder');
                      break;
                    default:
                      $('#modalFail').find('p').html('There was an error adding the location.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                      console.log('false success ', response);
                      self.model.set(self.model.previousAttributes());
                      break;
                  }
                },
                error: function (model, response, options) {
                  $('#modalFail').find('p').html('There was an error updating the location.  Please contact the administrator.');
                  $('#modalFail').toggleClass('hide', false);
                  console.log(model);
                  console.log(response);
                  console.log(options);
                },
                wait: true
              }
            );
            break;
          case 'edit':
            self.model.url = domainURL + '/api/Locations/Put';
            self.model.save(
              {
                'locationName': $('input[name=\'locationName\']').val(),
                'locationDesc': $('textarea[name=\'locationDesc\']').val(),
                'locationDisplayOrder': $('input[name=\'locationDisplayOrder\']').val(),
                'locationPhone': $('input[name=\'locationPhone\']').val(),
                'locationEmail': $('input[name=\'locationEmail\']').val(),
                'locationImgURL': $('input[name=\'locationImgURL\']').val(),
                'officeHours': $('input[name=\'officeHours\']').val(),
                'galleryHours': $('input[name=\'galleryHours\']').val(),
                'isRegional': $('input[name=\'isRegional\']:checked').val(),
                'isDisplay': $('input[name=\'isDisplay\']:checked').val(),
                'isActive': $('input[name=\'isActive\']:checked').val()
              },
              {
                success: function (model, response, options) {
                  switch (model.get('errorMessage')) {
                    case 'Success':
                      $('#modalSuccess').find('p').html('Success!  ' + self.model.get('locationName') + ' was updated successfully.');
                      $('#modalSuccess').toggleClass('hide', false);
                      phillips.Events.trigger('editTeamOrder');
                      break;
                    default:
                      $('#modalFail').find('p').html('There was an error updating the location.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                      console.log('false success ', response);
                      self.model.set(self.model.previousAttributes());
                      break;
                  }
                },
                error: function (model, response, options) {
                  $('#modalFail').find('p').html('There was an error updating the location.  Please contact the administrator.');
                  $('#modalFail').toggleClass('hide', false);
                  console.log(model);
                  console.log(response);
                  console.log(options);
                },
                complete: () => {
                  this.$('#loadingGif').toggleClass('hidden');
                },
                wait: true
              }
            );
            break;
          default:
            break;
        }
        break;
      case 'careers':
        const positionId = this.callType === 'add' ? 0 : this.model.get('positionId');
        url = {
          'add': `${domainURL}/api/Careers/Post`,
          'edit': `${domainURL}/api/Careers/Put`,
          'delete': `${domainURL}/api/Careers/delete`,
          'duplicate': `${domainURL}/api/Careers/duplicate`
        };
        this.model.url = url[this.callType];
        switch (this.callType) {
          case 'add':
          case 'edit':
            uploadPdf()
              .done((data) => {
                //get position type name and position type id
                const fileContainer = document.getElementById('pdfSource'),
                  inputValue = $('input#positionTypeName').val(),
                  positionTypeSelected = $('ul#positionTypeName').find('li[name=\'' + inputValue + '\']');
                let pdfSource = '',
                  positionTypeId = 0;
                if ($('div[id=\'pdfFileDownload\']').find('a').length) {
                  pdfSource = $('div[id=\'pdfFileDownload\']').find('a').html();
                }
                //if (fileContainer && fileContainer.files[0] && fileContainer.files[0].type.indexOf("pdf") > -1) {
                //	pdfSource = fileContainer.files[0].name;
                //        }
                if (data) {
                  pdfSource = data;
                }
                if (positionTypeSelected && positionTypeSelected.length > 0) {
                  positionTypeId = positionTypeSelected.val();
                }

                // var recipient = null;
                // if ($('input[name=\'recipient\']').val() !== '') {
                //   recipient = $('input[name=\'recipient\']').val();
                // }

                this.model.save(
                  {
                    'positionId': positionId,
                    'positionTypeId': positionTypeId,
                    'positionTypeName': inputValue,
                    'title': $('input[name=\'title\']').val(),
                    'recipient': $('input[name=\'recipient\']').val(),
                    'primaryFunction': CKEDITOR.instances.primaryFunction.getData(),
                    'responsibilities': CKEDITOR.instances.responsibilities.getData(),
                    'qualifications': CKEDITOR.instances.qualifications.getData(),
                    'directions': CKEDITOR.instances.directions.getData(),
                    'additionalInfo': CKEDITOR.instances.additionalInfo.getData(),
                    'educationAndTraining': CKEDITOR.instances.educationAndTraining.getData(),
                    'personalAttributes': CKEDITOR.instances.personalAttributes.getData(),
                    'workingConditions': CKEDITOR.instances.workingConditions.getData(),
                    'notes': CKEDITOR.instances.notes.getData(),
                    'effectiveDate': $('input[name=\'effectiveDate\']').val(),
                    'locationId': $('select[name=\'locationId\']').val(),
                    'pdfSource': pdfSource,
                    'isActive': $('input[name=\'isActive\']').prop('checked'),
                    'deleteFile': $('input[name=\'deleteFile\']').prop('checked')
                  },
                  {
                    success: (model, response) => {
                      switch (model.get('errorMessage')) {
                        case 'Success':
                          this.$('#loadingGif').toggleClass('hidden');
                          $('#modalResponseMessage').removeClass('hidden');
                          $('#modalResponseMessage').css('color', 'green');
                          $('#modalResponseMessage').html(`${self.model.get('title')} was updated successfully.`);
                          $('#modalResponseMessage').show().delay(5000).fadeOut();
                          phillips.Events.trigger("editTeamOrder");
                          break;
                        default:
                          this.$('#loadingGif').toggleClass('hidden');
                          if (response.responseJSON && response.responseJSON.errorMessage) {
                            $('#modalResponseMessage').html(`There was an error updating the position:  ${response
                              .responseJSON
                              .errorMessage}`);
                          } else {
                            $('#modalResponseMessage')
                              .html('There was an error updating the position.  Please contact the administrator.');
                          }

                          $('#modalResponseMessage').removeClass('hidden');
                          $('#modalResponseMessage').css('color', 'red');

                          $('#modalResponseMessage').show().delay(20000).fadeOut();

                          console.log('false success ', response);
                          this.model.set(this.model.previousAttributes());
                          break;
                      }
                    },
                    error: (model, response, options) => {
                      this.$('#loadingGif').toggleClass('hidden');
                      if (response && response.status && response.status === 401) {
                        $('#modalResponseMessage')
                          .html('your session expired redirecting to the login page...');
                        self.redirectToLogin();
                      } else if (response.responseJSON && response.responseJSON.errorMessage) {
                        $('#modalResponseMessage').html(`There was an error updating the position:  ${response
                          .responseJSON
                          .errorMessage}`);
                      } else {
                        $('#modalResponseMessage')
                          .html('There was an error updating the position.  Please contact the administrator.');
                      }
                      $('#modalResponseMessage').removeClass('hidden');
                      $('#modalResponseMessage').css('color', 'red');

                      $('#modalResponseMessage').show().delay(20000).fadeOut();
                      console.log(model);
                      console.log(response);
                      console.log(options);
                    },
                    complete: (model, response, options) => {
                      this.$('#loadingGif').toggleClass('hidden');
                    },
                    wait: true
                  }
                );
              })
              .fail(() => {
                $('#modalResponseMessage')
                  .html('There was an error updating the position.  Please contact the administrator.');
                $('#modalResponseMessage').removeClass('hidden');
                $('#modalResponseMessage').css('color', 'red');
                $('#modalResponseMessage').show().delay(20000).fadeOut();

              })
              .always(() => {
                this.$('#loadingGif').toggleClass('hidden');
              });
            break;
          case 'delete':
            const sendData = { positionId: positionId };
            this.model.destroy({
              data: JSON.stringify(sendData),
              contentType: 'application/json',
              success: (model, response, options) => {
                switch (response.errorMessage) {
                  case 'Success':
                    $('#modalSuccess').find('p').html('The position has been deleted.');
                    $('#modalSuccess').toggleClass('hide', false);
                    $('#modalSuccess').toggleClass('hidden', false);
                    phillips.Events.trigger("editTeamOrder");
                    break;
                  default:
                    $('#modalFail').find('p').html('There was an error deleting the position.  Please contact the administrator.');
                    $('#modalFail').toggleClass('hide', false);
                    $('#modalFail').toggleClass('hidden', false);
                    break;
                }
              },
              error: (model, response, options) => {
                if (response && response.status && response.status === 401) {
                  self.redirectToLogin();
                } else {
                  $('#modalFail').find('p').html('There was an error deleting the position.  Please contact the administrator.');
                }
                $('#modalFail').css({
                  'top': $('.modal').scrollTop() + 100,
                  'display': 'table'
                });
                console.log(model);
                console.log(response);
                console.log(options);
              },
              complete: () => {
                this.$('#loadingGif').toggleClass('hidden');
              },
              wait: true
            });
            break;
          case 'duplicate':
            this.model.save(
              { positionId: positionId },
              {
                success: function (model, response, options) {
                  switch (response.errorMessage) {
                    case 'Success':
                      $('#modalSuccess').find('p').html('The position has been duplicated.');
                      $('#modalSuccess').toggleClass('hide', false);
                      $('#modalSuccess').toggleClass('hidden', false);
                      phillips.Events.trigger("editTeamOrder");
                      break;
                    default:
                      $('#modalFail').find('p').html('There was an error duplicating the position.  Please contact the administrator.');
                      $('#modalFail').toggleClass('hide', false);
                      $('#modalFail').toggleClass('hidden', false);
                      break;
                  }
                },
                error: function (model, response, options) {
                  if (response && response.status && response.status === 401) {
                    self.redirectToLogin();
                  } else {
                    $('#modalFail').find('p').html('There was an error duplicating the position.  Please contact the administrator.');
                  }
                  $('#modalFail').toggleClass('hide', false);
                  $('#modalFail').toggleClass('hidden', false);
                  console.log(model);
                  console.log(response);
                  console.log(options);
                },
                complete: () => {
                  this.$('#loadingGif').toggleClass('hidden');
                },
                wait: true
              });
            break;
          default:
            break;
        }
        break;
      case 'auctionPurchase':
        // Validation for purchaseAmount value
        var $amtVal = $('#purchaseAmount').val();
        $amtVal = $amtVal.replace(/,/g, '');
        if (10 > parseFloat($amtVal) || parseFloat($amtVal) > 999999) {
          $('span\[data-valmsg-for=\'purchaseAmount\'\]').html('Amount must be at least 10 and less than 999,999');
          return false;
        } else if (!($amtVal.length) > 0 || isNaN(parseFloat($amtVal))) {
          $('span\[data-valmsg-for=\'purchaseAmount\'\]').html('Please enter a valid amount between 10 and less than 999,999');
          return false;
        }
        this.$('input:not(\[type=\'hidden\'\])').each((i, el) => {
          if ($(el).data('valid')) {
            this.validForm = true;
          } else {
            this.validForm = false;
            $('span\[data-valmsg-for=\'' + $(el).attr('id') + '\'\]').html($('span\[data-valmsg-for=\'' + $(el).attr('id') + '\'\]').data('valmsg'));
            this.$('#loadingGif').toggleClass('hidden', false);
            return false;
          }
        });
        if (!this.validForm) {
          this.$('#loadingGif').toggleClass('hidden', false);
          return this.validForm;
        }
        break;
      case 'editorial':
        const formData = this.parseForm($form.serializeArray());
        formData.isActive = this.$('#isActive').is(':checked');
        formData.alternateDescription = CKEDITOR.instances.alternateDescription.getData();
        this.model.save(formData)
          .done((model, response, options) => {
            $('#modalSuccess').find('p').html('The article has been updated.');
            $('#modalSuccess').removeClass('hide', false);
            return model;
          })
          .fail(() => {
            $('#modalFail').find('p').html('There was an error updating the article.  Please contact the administrator.');
            $('#modalFail').removeClass('hide', false);
          })
          .always(() => {
            this.$('#loadingGif').toggleClass('hidden');
          });
        break;
      case 'maker':
        $('#loadingGif').removeClass('hidden');
        const formDataMaker = this.parseForm($form.serializeArray());
        formDataMaker.biography = CKEDITOR.instances.biography.getData();
        formDataMaker.firstQuote = CKEDITOR.instances.firstQuote.getData();
        formDataMaker.secondQuote = CKEDITOR.instances.secondQuote.getData();
        $('#modalResponseMessage').hide();
        this.model.save(formDataMaker).then((model, response, options) => {
          $('#modalResponseMessage').removeClass('hidden');
          $('#modalResponseMessage').css('color', 'green');
          $('#modalResponseMessage').html('saved! you can continue working on this modal');
          $('#modalResponseMessage').show().delay(5000).fadeOut();

          $('#loadingGif').addClass('hidden');
          return model;
        },
          (model, response, options) => {
            $('#loadingGif').addClass('hidden');
            $('#modalResponseMessage').removeClass('hidden');
            $('#modalResponseMessage').css('color', 'red');
            $('#modalResponseMessage').html(model.responseJSON.message);
            $('#modalResponseMessage').show().delay(20000).fadeOut();
            console.log('model', model);
            console.log('response', response);
            console.log('options', options);
          });
        break;
      default:
        //modal ajax default
        const defaultData = this.parseForm($form.serializeArray());
        this.model.save(defaultData).then((model, response, options) => {
          $('#modalSuccess').find('p').html('The article has been updated.');
          $('#modalSuccess').toggleClass('hide', false);
          return model;
        },
          () => {
            $('#modalFail').find('p').html('There was an error updating the article.  Please contact the administrator.');
            $('#modalFail').css({
              'top': $('.modal').scrollTop() + 100,
              'display': 'table'
            });
          });
        break;
    }
  },
  refreshPage(e) {
    e.preventDefault();
    window.location.reload();
  },
  selectTag(e) {
    var $text = $(e.currentTarget).html();
    var $val = $(e.currentTarget).val();
    $('input#videoTags, input#departmentLocations, input#positionTypeName').val($text);
    $('input#videoTags, input#departmentLocations, input#positionTypeName').data('val', $val);
    $('ul#videoTags li, ul#departmentLocations li, ul#positionTypeName li').hide();
  },
  addTag(e) {
    e.preventDefault();
    var self = this;
    //validate if videoTags input is blank OR already in the list
    if ($('input.addTagInput').val() == '') {
      return false;
    } else {
      // videoTags
      if ($(e.target).hasClass('addTag')) {
        if (self.model.get('videoTags').findWhere({ 'tagDesc': $('input#videoTags').val() })) {
          return false;
        } else {
          this.tagModel = new TagModel();
          this.tagModel.save(
            {
              'tagDesc': $('input#videoTags').val(),
              'tagID': 0,
              'tagVideoID': 0,
              'videoID': function () {
                if (self.callType === 'add') {
                  if (self.model.get('videoID') === 0 || self.model.get('videoID') == '') {
                    // console.log(this.model.get("videoID"));
                  }
                } else {
                  return self.model.get('videoID');
                }
              }()
            },
            {
              success: function (model, response, options) {
                switch (model.get('errorMessage')) {
                  case 'Success':
                    self.tagModel.set({
                      'id': model.get('tagID'),
                      'tagDesc': model.get('tagDesc'),
                      'tagVideoID': model.get('tagVideoID'),
                      'videoID': self.model.get('videoID')
                    });
                    // triggers 'addTag' event and passes tagModel as model
                    phillips.Events.trigger('addTag', self.tagModel);
                    // self.videoTagsCollection.add(model);
                    self.model.get('videoTags').add(model);
                    $('input#videoTags').val('');
                    break;
                  default:
                    $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                    $('#modalFail').toggleClass('hide', false);
                    self.tagModel.set(self.tagModel.previousAttributes());
                    break;
                }
              },
              error: function (model, response, options) {
                console.log(model);
                console.log(response);
                console.log(options);
                $('#modalFail').find('p').html('There was an error updating the user.  Please contact the administrator.');
                $('#modalFail').toggleClass('hide', false);
              },
              wait: true
            }
          );
        }
        // departmentLocations
      } else if ($(e.target).hasClass('addLocation')) {
        var locationsArray = [];
        _.forEach(this.model.get('departmentLocations').models, function (item, i) {
          var locName = item.get('location').get('locationName');
          locationsArray.push(locName);
        }, this);
        if (locationsArray.indexOf($('input[name=\'departmentLocations\']').val()) !== -1) {
          return false;
        }
        var labels = ['Email', 'Phone'];
        // create a FE phillips.DepartmentLocation model on the spot
        // to add to the parent model's  departmentLocation collection
        // new models created from inside -> out
        this.newCommPhoneModel = new CommunicationModel();
        this.newDeptLocCommPhoneModel = new DeptLocCommModel();
        this.newDeptLocModel = new DeptLocModel();

        var depLocCommClone = this.newDeptLocModel.get('departmentLocationCommunications').at(0);
        var locationClone = this.newDeptLocModel.get('location');

        // validate that departmentLocationCommunications exists
        if (depLocCommClone.get('communication') !== undefined) {
          // Set first model as email communication model

          depLocCommClone.get('communication').set({
            'communicationTypeID': 3
          });
        } else {
          // Create first model as email communication model
          this.newCommEmailModel = new CommunicationModel();
          this.newDeptLocCommEmailModel = new DeptLocCommModel();
          this.newCommEmailModel.set({
            'communicationTypeID': 3
          });
          this.newDeptLocCommEmailModel.set({
            'communication': this.newCommEmailModel
          });
          this.newDeptLocModel.get('departmentLocationCommunications').add(this.newDeptLocCommEmailModel);
        }

        // Create and Add Phone Model to departmentLocationCommunications collection
        this.newCommPhoneModel.set('communicationTypeID', 1);
        this.newDeptLocCommPhoneModel.set('communication', this.newCommPhoneModel);
        this.newDeptLocModel.get('departmentLocationCommunications').add(this.newDeptLocCommPhoneModel);

        // Update location model with locationClone
        this.newDeptLocModel.get('location').set({
          'locationID': $('input#videoTags, input#departmentLocations').data('val'),
          'departmentID': this.model.get('departmentID'),
          'locationName': $('input#departmentLocations').val()
        });

        // Update departmentLocation model to set locationID
        this.newDeptLocModel.set('locationID', $('input#videoTags, input#departmentLocations').data('val'));

        // triggers VideoTagView.addTag, which uses the updated collection
        // to update the badges
        phillips.Events.trigger('addTag', this.newDeptLocModel);

        // adds new departmentLocation model to departmentLocations collection
        this.model.get('departmentLocations').add(this.newDeptLocModel);
        this.setupEditTags(this.model.get('departmentLocations'), labels, $('input#departmentLocations').val());
      }
    }
  },
  setupVideoBox: function (key, badgeDesc, label) {
    this.$el.append(this.badgeBoxTemp({ 'label': label, 'modelKey': key }));
    var self = this;
    this.videoTagsView = new VideoTagView({
      el: '.tagBox#' + key,
      collection: function () {
        if (self.model.get(key)) {
          return self.model.get(key);
        } else {
          const model = Backbone.Model.extend({
            defaults: {
              'errorMessage': '',
              'videoLotID': 0,
              'saleNumber': '',
              'lotNumber': '',
              'tagID': 0,
              'lotExtension': '',
              'videoID': 0
            }
          });
          return new Backbone.Collection([], model);
        }
      }(),
      'key': key,
      'badgeDesc': badgeDesc
    });

    phillips.Events.trigger('showTags');
  },
  setupEditTags: function (collection, labels, locationName) {
    var tagWrapperEl = this.$el.find('#locationWrapper');
    var i;

    // only render last added model, not the whole list
    if (tagWrapperEl.html() !== '') {
      var lastModel = collection.at(collection.length - 1);
      $('.tagBox#departmentLocations').append();
      for (i = 0; i < labels.length; i++) {
        tagWrapperEl.append(this.template({
          'label': locationName + ' ' + labels[i],
          'modelKey': 'location' + labels[i] + (collection.length - 1),
          'readonly': ''
        }));
      }
    } else {
      // department
      _.forEach(collection.models, function (item, k) {
        for (i = 0; i < labels.length; i++) {
          tagWrapperEl.append(this.template({
            'label': item.get('location').get('locationName') + ' ' + labels[i],
            'modelKey': 'location' + labels[i] + k,
            'readonly': ''
          }));
        }
        // console.log(item);
        // map values to inputs
        _.forEach(item.get('departmentLocationCommunications').models, function (model, i) {
          if (model.get('communication').get('communicationTypeID') === 3) {
            this.$el.find('input[name=\'locationEmail' + k + '\']').val(model.get('communication').get('communicationDesc'));
          } else if (model.get('communication').get('communicationTypeID') === 1) {
            this.$el.find('input[name=\'locationPhone' + k + '\']').val(model.get('communication').get('communicationDesc'));
          }
        }, this);
        // _.map(item.get("location").attributes, function(value, key) {
        // 	this.$el.find("input[name='"+ key + k + "']").val(value);
        // }, this);
      }, this);
    }
  },
  validateInput: function (e) {
    var emailRegex = new RegExp(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm);
    if (e.target.hasAttribute('required') && $(e.target).val().length < 1) {
      this.validInput = false;
      $(e.target).data('valid', false);
      if ($('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').length > 0) {
        $('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').html($('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').data('valmsg'));
      }
    } else {
      if (($(e.target).attr('id') === 'email') && (emailRegex.test($(e.target).val()) === false)) {
        this.validInput = false;
        $(e.target).data('valid', false);
        if ($('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').length > 0) {
          $('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').html($('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').data('valmsg'));
          return false;
        }
      }
      $('span\[data-valmsg-for=\'' + $(e.target).attr('id') + '\'\]').html('');
      this.validInput = true;
      $(e.target).data('valid', true);
    }
  },
  close: function (e) {
    phillips.Events.trigger('close');
    this.$el.empty();
    this.undelegateEvents();
    this.stopListening();
    // this.remove();
    this.unbind();
    this.model.unbind('change', this.render);
    // $(this.el).removeData().unbind();
  },
  handleChange: function (e) {
    var $el = $('#uploadOptions').parent('.form-group');
    this.toggleShow($(e.target).val(), $el);
  },
  toggleShow: function (value, $el) {
    if (value === 'calendar_only') {
      $el.addClass('hide');
    } else {
      if ($el.hasClass('hide')) {
        $el.removeClass('hide');
      }
    }
  },
  onFileChange: function (e) {
    const target = e.target;
    const $img = this.$(`.${$(target).attr('name')}`);
    if ($img.length > 0 && target.files.length > 0) {
      fileToBase64(target.files[0]).then((url) => {
        $img.attr('src', url);
      });
    }
  },
  hideGrid: function () {
    $('#bbGrid-container').toggleClass('hide', true);
    $('#myModal').toggleClass('hide', false);
  },
  redirectToLogin: function () {
    $('#modalFail').find('p').html('Your session has expired, redirecting to login...');
    $('#modalFail').toggleClass('hide', false);
    $('#modalFail').toggleClass('hidden', false);
    setTimeout(() => { window.location.href = `/Account/Login?returnUrl=${window.location.pathname}${window.location.search}` }, 5000);
  }
});

export default ModalView;
